module.exports = __webpack_public_path__ + "static/media/envanterium-logo-text-only-dark.11fb0287.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Logo/envanterium-logo-text-only-dark.png
// module id = 232
// module chunks = 0